import React, { Suspense, useContext } from "react";
import App from "../components/app/app";
import "../i18n";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import Error500 from "src/components/utils/errors/500/500";
import Error404 from "src/components/utils/errors/404/404";
import { RestApiClientContext } from "src/hooks/context/pageContext";
import { generateUUID } from "src/utils/generateUUID";
import StackTrace from "stacktrace-js";
import { UserProviderV2 } from "src/hooks/context/userInfo";
import { Result, Button } from "antd";

const AppWrapper = () => {
  const restApiClient = useContext(RestApiClientContext);

  function myErrorFallBack({ error }: FallbackProps) {
    var errorStackTrace: string = error.stack ?? error.status;
    var actualError = sessionStorage.getItem("last-error");

    if (actualError) {
      const errors = JSON.parse(actualError);
      errors.push({ message: encodeURIComponent(error.message), method: 'generic-error', parameters: JSON.stringify(error.stack) });
      sessionStorage.setItem("last-error", JSON.stringify(errors));
    } else {
      sessionStorage.setItem("last-error", JSON.stringify([{ message: encodeURIComponent(error.message), method: 'generic-error', parameters: JSON.stringify(error.stack) }]));
    }
    if (errorStackTrace.includes("404")) {
      return <Error404 error={error} />;
    } else if (error.status === 503) {
      return  <Result
        status="500"
        title="Maintenance mode."
        subTitle="The system is currently under maintenance. Please try again later."
        extra={[
          <Button type="primary" key="reload" onClick={() => window.location.reload()}>Reload</Button>,
        ]}
      />

    } else {
       return <Error500 error={error} />;
    }
  }
  const sendNotificationsErrorEmail = async (error: Error, info: { componentStack: string }): Promise<void> => {
    try {
      // ✅ Obtener stack trace legible
      const stackFrames = await StackTrace.fromError(error);
      const readableStack = stackFrames
        .map((sf) => {
          const func = sf.functionName || "anonymous";
          const file = sf.fileName || "unknown file";
          const line = sf.lineNumber || 0;
          return `
         <li>
          <p>Error en la función: <strong> [ ${func} ] </strong></p>
          <br />
          <p>Se encuentra en el archivo:  <strong> [ ${file} ] </strong>  Linea: <strong> [ ${line} ] </strong></p>
         </li>
          `;
        })
        .join("<br />");

      const errorData = {
        tenantURL: window.location.href,
        errorCode: generateUUID(),
        message: error.message,
        stackTrace: readableStack,
        componentStack: info.componentStack,
        time: new Date().toISOString(),
        userAgent: navigator.userAgent,
      };

      // Lo comentamos temporalmente para que no se envíen los errores
      //restApiClient.sendNotificationsErrorEmail(errorData);
    } catch (traceError) {
      console.error("Error al generar stack trace:", traceError);
    }
  };



  return (
    <Suspense fallback={null}>
      <ErrorBoundary FallbackComponent={myErrorFallBack}
        onError={sendNotificationsErrorEmail}>
        <UserProviderV2>
          <App />
        </UserProviderV2>
      </ErrorBoundary>
    </Suspense>
  );
};

export default AppWrapper;